import React, {Component} from 'react';
import Timeline, {defaultSubHeaderLabelFormats} from 'react-calendar-timeline/lib';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import {getClerkAvailability} from "../../data/user_api";
import {CLERK_LEAVE_LIST_API_URL, INSPECTION_API_URL} from "../../constants/api_routes";
import Loader from '../universal/loader';
import {Header, Message,Popup,Input,Form,Button,Dropdown, Segment} from 'semantic-ui-react';
import InspectionContainer from "../../containers/inspection_container";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

class AssignClerk extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clerkList: [],
            groups: [],
            items: [],
            assignedClerkId: undefined,
            assignedClerkName: undefined,
            defaultStartTime: undefined,
            defaultEndTime: undefined,
            date: moment().format("YYYY-MM-DD"),
            inspectionId: undefined,
            successAssign: false,
            clerkDetail: {},
            showTimeline:true,
            filter:false,
            filteredGroups:[],
            filteredClerkList:[],
            dateValid:true,
            inspectionDate:undefined,
            clerkList:undefined,
            clerkToChange:undefined
        }
    }

    componentDidMount() {
        this.setState({assignedClerkName: this.props.currentAssignedUser ? this.props.currentAssignedUser.name : undefined});
        this.setState({
            date: this.props.date,
            inspectionId: this.props.inspectionId ? this.props.inspectionId : this.props.newInspectionId
        });
        if (this.props.date) {
            this.setState({inspectionDate:this.props.date});
            this.getClerkUsersAndAvailability(this.props.date).then(() => {
            });
        }
    }

    checkEndDateAfterInspectionDate = (end_date) =>
        {
        return moment(end_date).isAfter(moment(this.state.inspectionDate))
    }

    checkAndAlertEndDate =(end_date) =>{
           if(moment(end_date).isBefore(moment(this.state.inspectionDate))){
                        window.alert(`The inspection date (${moment(this.state.inspectionDate).format("DD-MM-YYYY")}) is after the assigned clerk's end date (${moment(end_date).format("DD-MM-YYYY")}). The clerk assignment will still proceed as directed.`)
                    }
    }

    backgroundColorChoice = (data,end_date) => {
        if(end_date && !this.checkEndDateAfterInspectionDate(end_date)) {
            return "#b90202"
        }
        if (data) {
            let _data = data
            try {
                let parsedData = JSON.parse(_data)
                _data = parsedData
            }
            catch (e) { _data = data }
            let weekDayName = moment(this.state.defaultStartTime, "YYYY-MM-DD HH:mm:ss Z").format("dddd").toLowerCase();
            let dataDict = { null: null, 1: "#0c580c", 2: "#e59400", 3: "#b90202" }
            let color = dataDict[_data[weekDayName]]
            return color
        }
    }
    parseWeeklyAvailability = (_data) => {
        if (_data) {
            let data = _data
            try {
                let parsedData = JSON.parse(data)
                data = parsedData
            }
            catch (e) { data = _data }
            let dataDict = { null: "Not Set", 1: "Available", 2: "Partially Available", 3: "Unavailable" }
            return "MON-"+(dataDict[data["monday"]] || "Not Set")+ " TUE-"+(dataDict[data["tuesday"]]|| "Not Set") + " WED-"+(dataDict[data["wednesday"]]|| "Not Set") + " THU-"+(dataDict[data["thursday"]]|| "Not Set") + " FRI-"+(dataDict[data["friday"]]|| "Not Set") + " SAT-"+(dataDict[data["saturday"]]|| "Not Set") + " SUNDAY-"+(dataDict[data["sunday"]]|| "Not Set") 
        }
    }
    
    handleAssign = async (e, id, name, endDate = undefined) => {
        //CHECK END DATE HERE
        if(this.props.viewOnly){
            return null;
        }

        if(endDate) {
            this.checkAndAlertEndDate(endDate)
        }
        this.setState({showTimeline:false});
        this.props.assignJob(INSPECTION_API_URL, {
            inspection_id: this.state.inspectionId,
            user_id: id
        }, this.successCallback);
        this.setState({clerkDetail: {id: id, assignedClerkName: name}});
    };

        handleClerkChange = async (inspection_id) => {       
        this.setState({showTimeline:false,assignedClerkName:undefined});
        this.props.assignJob(INSPECTION_API_URL, {
            inspection_id: inspection_id,
            user_id: this.state.clerkToChange
        }, this.successCallbackClerkChange);
    };


    handleClerkFilter = () => {
        let filterValue = this.state.clerkFilter;
        if(filterValue.length > 1 ){
            this.setState({filter:true});
            this.setState({filteredGroups:this.state.groups.filter((e) => {
                return (e.name.toUpperCase().indexOf(filterValue.toUpperCase()) >=0);
            })});
        }
        else {
            this.setState({filter:false});
        }
    };

    successCallback = (response) => {
        if (response.success) {
            if (this.props.date) {
                this.getClerkUsersAndAvailability(this.props.date).then(() => {
                    this.setState({
                        assignedClerkId: this.state.clerkDetail.id,
                        assignedClerkName: this.state.clerkDetail.assignedClerkName,
                        showTimeline:true
                    });
                });
            }
        }
        else {
            this.setState({successAssign: false, errorMessage: "Something went wrong!!",showTimeline:true});
        }
    };

    successCallbackClerkChange = (response) => {
        if (response.success) {
            if (this.state.inspectionDate) {
                this.getClerkUsersAndAvailability(this.state.inspectionDate).then(() => {
                    this.setState({
                        showTimeline:true
                    });
                });
            }
        }
        else {
            this.setState({successAssign: false, errorMessage: "Something went wrong!!",showTimeline:true});
        }
    };

    handleDateChange = () => {
        if (this.state.inspectionDate) {
            this.setState({showTimeline:false});
            this.getClerkUsersAndAvailability(this.state.inspectionDate).then(() => {
                this.setState({showTimeline:true});
            });
        }
    };

    itemRenderer = ({item}) => {
        return (
            <Popup on="click"
                trigger={<div className="format-bold" style={{width:'100%',overflow:'ellipsis'}}>{item.title}</div>}
                content={
                    <div>
                        {item['jobType']?<div className="pad-top">
                            <div><span className="pad-bottom format-bold ">Start Time : </span><span> {item['time']}</span></div>
                            <div><span className="pad-bottom format-bold ">Address &nbsp;&nbsp; : </span><span> {item['address']}</span></div>
                            <div><span className="pad-bottom format-bold ">Job Type &nbsp; : </span><span className="formatcase"> {item['jobType']}</span></div>
                            <div><span className="pad-bottom format-bold ">Size &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;: </span><span> {item['propertySize']}</span></div>
                            <div><span className="pad-bottom format-bold ">Agent &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; : </span><span> {item['agent']}</span></div>
                            <div><span className="pad-bottom format-bold ">Status &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; : </span><span> {item['status']}</span></div>
                        <Segment>
                            <Dropdown value={this.state.clerkToChange}
                            onChange={(e, data) => {this.setState({ clerkToChange: data.value });
                                 let clerk = this.state.clerkList.find(item => item.value === data.value);
                                 if (clerk && clerk.end_date) { this.checkAndAlertEndDate(clerk.end_date);};
                        }} search  selection options={this.state.clerkList}
                            />
                            <Button onClick={ ()=>{this.handleClerkChange(item["insp_id"])}}disabled={!this.state.clerkToChange}>Change Clerk</Button>
                        </Segment>
                        </div> :
                            <div className="pad-top">
                                <div><span className="pad-bottom format-bold">Start Time : </span><span> {item['time']}</span></div>
                                <div><span className="pad-bottom format-bold">Leave Comments: </span><span> {item['leaveNote']}</span></div>
                            </div>
                        }
                    
                        
                    </div>
                }
                flowing
                style={{WebkitBoxShadow: ' 0px 0px 18px 3px rgba(0,0,0,0.3)',
                    MozBoxShadow: ' 0px 0px 18px 3px rgba(0,0,0,0.3)',
                    boxShadow: ' 0px 0px 18px 3px rgba(0,0,0,0.3)'}}
                hideOnScroll
                header={<div><Header content={item['jobType']?"Inspection Details":"Leave Details"} color="blue" /></div>}
            />
            );
    };

    getClerkUsersAndAvailability = async (date) => {
        const Options = await getClerkAvailability(CLERK_LEAVE_LIST_API_URL, date);
        const clerkOptions = Options.clerks;
        const adminOptions = Options.admins;
        const colorClass ={"ci":'assigned-inspection-ci',"inv/ci":'assigned-inspection-ci',"co":'assigned-inspection-co',"inv":'assigned-inspection-inv', "pv":"assigned-inspection-pv", "rev":"assigned-inspection-rev", "cln":"assigned-inspection-cln", "sng":"assigned-inspection-sng"}
        this.setState({defaultStartTime: Options['default_start_time'], defaultEndTime: Options['default_end_time']});
        let newObj = [];
        let groupObj = [];
        var items = [];
        const totalClerks = clerkOptions.length;
        if (totalClerks > 0) {
            for (let i = 0; i < totalClerks; i++) {
                let obj = {
                    key: clerkOptions[i].id,
                    text: clerkOptions[i].name,
                    value: clerkOptions[i].id,
                    end_date:clerkOptions[i].end_date
                };
                let gobj = {
                    id: clerkOptions[i].id,
                    title: <Popup wide="very" content={<ul>
                        {clerkOptions[i].end_date && <li><strong>End Date:</strong> {clerkOptions[i].end_date}</li>}
                        <li><strong>Availability Comment:</strong> {clerkOptions[i].clerk_availability_comment}</li>
                        <li><strong>Areas Covered:</strong> {clerkOptions[i].areas_covered}</li>
                        <li><strong>Weekly Availability:</strong> {this.parseWeeklyAvailability(clerkOptions[i].weekly_availability)} </li>
                        {clerkOptions[i].pvs.length > 0?<li><strong>Property Visits</strong><ul>
                            {clerkOptions[i].pvs.map((visit)=>{if(visit.visit_status != "pending"){return <li>{visit.visit_time} - {visit.visit_address}</li>}})}
                        </ul></li> : null }
                        </ul>} trigger={<div style={{ cursor: 'pointer', backgroundColor: clerkOptions[i].excluded_companies.includes(this.props.companyId)? "#eaeaea" : this.backgroundColorChoice(clerkOptions[i].weekly_availability,clerkOptions[i].end_date) }}
                onClick={(e) => clerkOptions[i].excluded_companies.includes(this.props.companyId) ? null : this.handleAssign(e, clerkOptions[i].id, clerkOptions[i].name,clerkOptions[i].end_date)}>
                    {clerkOptions[i].pvs.length > 0? <Button compact color="red" size="mini">PV</Button>:null }
                    {clerkOptions[i].name} 
                    </div>}/>,
                    name:clerkOptions[i].name
                };

                clerkOptions[i].inspections.forEach(function (ins) {
                    let iobj = {
                        id: "inspection" + ins['inspection_id'],
                        insp_id:ins['inspection_id'],
                        group: clerkOptions[i].id,
                        title: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " - " + moment(ins['end_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " _ "+ins['inspection_type'].toUpperCase() + " _ "+ins['property_size'] +"BR _"+ ins['agent_profile_name']+" _ "+ ins['property_address'],
                        className: colorClass[ins['inspection_type']],
                        start_time: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        end_time: moment(ins['end_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        jobType:ins['inspection_type'],
                        time: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm"),
                        agent:ins['agent_profile_name'],
                        propertySize:ins['property_size']+" Bedroom(s)",
                        address:ins['property_address'],
                        status:ins["status"]
                    };
                    items.push(iobj);
                });

                clerkOptions[i].leaves.forEach(function (leave) {
                    let iobj = {
                        id: "leave" + leave['leave_id'],
                        group: clerkOptions[i].id,
                        title: moment(leave['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " - " + moment(leave['end_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " | Leave Comments:" + leave['description'] ,
                        className: 'clerk-leave',
                        start_time: moment(leave['start_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        end_time: moment(leave['end_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        time: moment(leave['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm"),
                        jobType:undefined,
                        leaveNote:leave['description']
                    };
                    items.push(iobj);
                });

                newObj.push(obj);
                groupObj.push(gobj);
            }
        }

        const totalAdmins = adminOptions.length;
        if (totalAdmins > 0) {
            for (let i = 0; i < totalAdmins; i++) {
                let obj = {
                    key: adminOptions[i].id,
                    text: adminOptions[i].name,
                    value: adminOptions[i].id
                };

                let gobj = {
                    id: adminOptions[i].id,
                    title: <div style={{cursor: 'pointer'}}
                                onClick={(e) => this.handleAssign(e, adminOptions[i].id, "#" + adminOptions[i].name)}>{"#" + adminOptions[i].name}</div>,
                    name: adminOptions[i].name
                };

                adminOptions[i].inspections.forEach(function (ins) {
                    let iobj = {
                        id: "inspection" + ins['inspection_id'],
                        group: adminOptions[i].id,
                        title: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " - " + moment(ins['end_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm") + " _ "+ins['inspection_type'].toUpperCase() + " _ "+ins['property_size'] +"BR _"+ ins['agent_profile_name']+" _ "+ ins['property_address'],
                        className: colorClass[ins['inspection_type']],
                        start_time: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        end_time: moment(ins['end_time'], "YYYY-MM-DD HH:mm:ss Z"),
                        jobType:ins['inspection_type'],
                        time: moment(ins['start_time'], "YYYY-MM-DD HH:mm:ss Z").format("HH:mm"),
                        agent:ins['agent_profile_name'],
                        propertySize:ins['property_size']+" Bedroom(s)",
                        address:ins['property_address'],
                        status:ins["status"]
                    };
                    items.push(iobj);
                });
                newObj.push(obj);
                groupObj.push(gobj);
            }
            this.setState({clerkList: newObj, groups: groupObj, items: items});
        }
    };


    render() {
        const minTime = moment(this.state.defaultStartTime, "YYYY-MM-DD HH:mm:ss Z").startOf('day').valueOf();
        const maxTime = moment(this.state.defaultEndTime, "YYYY-MM-DD HH:mm:ss Z").endOf('day').valueOf();

        const ukSubHeaderLabelFormats = Object.assign(
            {},
            defaultSubHeaderLabelFormats,
            {
                hourShort: 'HH',
                hourLong: 'HH',
                minuteLong: 'HH:mm'
            }
        );

        const ukHeaderLabelFormats = Object.assign({}, defaultSubHeaderLabelFormats, {
            yearShort: 'YY',
            yearLong: 'YYYY',
            monthShort: 'MM-YY',
            monthMedium: 'MM-YYYY',
            monthMediumLong: 'MMM YYYY',
            monthLong: 'MMMM YYYY',
            dayShort: 'DD-MM-YY',
            dayLong: 'DD-MM-YYYY (dddd)',
            hourShort: 'HH',
            hourMedium: 'HH:00',
            hourMediumLong: 'DD-MM-YYY, HH:00',
            hourLong: 'dddd, DD-MM-YYY, HH:00',
            time: 'DD-MM-YYYY HH:mm:ss'
        });

        const defaultStartTimeDate = moment(this.state.defaultStartTime, "YYYY-MM-DD HH:mm:ss Z");
        const defaultEndTimeDate = moment(this.state.defaultEndTime, "YYYY-MM-DD HH:mm:ss Z");

        const groups = this.state.groups;
        const items = this.state.items;
        return (<div style={{minHeight:'500px'}}>
            {this.state.groups.length > 0 ? <div>
                <Header textAlign='center' size='large'>{(this.props.startTime && this.props.endTime ) ?"Assign Clerk ("+moment(this.props.startTime, 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')+" - "+moment(this.props.endTime, 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')+")":"Clerks Schedule on "+moment(this.state.inspectionDate,"YYYY-MM-DD HH:mm:ss Z").format("DD-MM-YYYY")}</Header>
                {this.props.viewOnly? <div style={{width:'50%',paddingLeft:'5%'}}>
                    <Form>
                        <div className='fields'>
                            <div className='ui field fourteen wide'>
                                <span className='required field'><label><b>Date: </b></label></span><span className={this.state.dateValid?'field':'field ui error'}><DayPickerInput
                                placeholder="DD-MM-YYYY"
                                dayPickerProps={{
                                    todayButton: 'Today',
                                    firstDayOfWeek : 1,
                                }}
                                format="DD-MM-YYYY"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                value={this.state.inspectionDate}
                                onDayChange={day => {if(day) { this.setState({
                                    inspectionDate: day,
                                    dateValid:true,
                                })}
                                else {
                                    this.setState({dateValid:false,inspectionDate:undefined});
                                }
                                }}/></span>
                            </div>
                            <div className="two wide">
                                <Button style={{marginTop:'25%'}} content="Check" primary fluid onClick={this.handleDateChange}/>
                            </div>
                        </div>
                    </Form>
                </div>: this.state.assignedClerkName ?
                    <Message color='green'><b> {this.state.assignedClerkName} </b> is assigned for
                        Inspection</Message> : <Message color='orange'>Inspection Needs Assigning</Message>
                }
                 <div className='scrolling-time'>
                     {this.state.showTimeline ? <Timeline
                        groups={this.state.filter?this.state.filteredGroups:groups}
                        items={items}
                        defaultTimeStart={defaultStartTimeDate}
                        defaultTimeEnd={defaultEndTimeDate}
                        canMove={false}
                        canResize={false}
                        stackItems
                        sidebarContent={<div><div>Clerks</div><div className="pad-top"><Input size="mini" icon='search' fluid inverted onChange={async (e)=> { await this.setState({clerkFilter:e.target.value});this.handleClerkFilter();}}/></div></div>}
                        visibleTimeStart={minTime}
                        visibleTimeEnd={maxTime}
                        subHeaderLabelFormats={ukSubHeaderLabelFormats}
                        headerLabelFormats = {ukHeaderLabelFormats}
                        canvasTimeStart={defaultStartTimeDate}
                        canvasTimeEnd={defaultEndTimeDate}
                        itemRenderer={this.itemRenderer}
                        onTimeChange={
                            function (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) {
                                if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
                                    updateScrollCanvas(minTime, maxTime)
                                } else if (visibleTimeStart < minTime) {
                                    updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
                                } else if (visibleTimeEnd > maxTime) {
                                    updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
                                } else {
                                    updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
                                }
                            }}
                    />:<Loader contain={true} customText="Loading Clerk Schedule" />}
                </div>

            </div> : <Loader contain={true} customText="Loading Clerk Schedule" />}
        </div>);
    }

}

export default InspectionContainer(AssignClerk);


// WEBPACK FOOTER //
// ./src/views/inspection/assign_clerk.js